import axios from 'axios';
import { URL_EMAIL_CONFIRMATION, URL_EMAILS } from '../constants/urls';

export const FETCH_EMAIL_CONFIRM_BEGIN = 'FETCH_EMAIL_CONFIRM_BEGIN';
export const FETCH_EMAIL_CONFIRM_SUCCESS = 'FETCH_EMAIL_CONFIRM_SUCCESS';
export const FETCH_EMAIL_CONFIRM_FAILURE = 'FETCH_EMAIL_CONFIRM_FAILURE';

const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isNewEmailFormat = (id) => UUID_REGEX.test(id);

export const confirmEmail =
  (token, code, useOTPFlow = false) =>
  async (dispatch) => {
    dispatch({ type: FETCH_EMAIL_CONFIRM_BEGIN });

    try {
      if (useOTPFlow && isNewEmailFormat(token)) {
        await axios.put(`${URL_EMAILS}/${token}/verify_link`, null, {
          params: { code },
        });
      } else {
        await axios.put(`${URL_EMAIL_CONFIRMATION}${token}`, null, {
          params: { code },
        });
      }

      dispatch({ type: FETCH_EMAIL_CONFIRM_SUCCESS });

      return true;
    } catch (error) {
      dispatch({
        payload: error && error.response && error.response.statusText,
        type: FETCH_EMAIL_CONFIRM_FAILURE,
      });
      return false;
    }
  };
